export default __webpack_public_path__ + "static/media/whatsapp_white.474ee56b.svg";